import { useTranslation } from "next-i18next";
import BrandSwiper from "../global/swiper/BrandSwiper";

const CategoryBanners = ({ brands }) => {
  const { t } = useTranslation("common");

  return (
    <div className="sm:mb-9">
      <div className="flex items-center justify-between mb-4">
        <p className="text-center sm:text-2xl font-bold">{t("Our Brands")}</p>
        <span className="max-sm:hidden text-purple-600 font-bold cursor-pointer hover:underline transition-all duration-500">
          {t("View All")}
        </span>
      </div>
      <BrandSwiper fromCategory={brands} />
    </div>
  );
};

export default CategoryBanners;
